import { axiosInstance } from 'network/apis';

const creditIncentive = async (data) => {
  return await axiosInstance.post('MyProxy/time-slot-payments', data, { handlerEnabled: true });
};

export default {creditIncentive};